<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab
    *ngIf="usersRol.CONSULTAR_OPERADORES"
    tabTitle="Consulta"
    tabIcon="search-outline"
    responsive
    style="height: 80vh"
  >
    <div>
      <button
        nbButton
        shape="round"
        size="small"
        class="buttontz float-right"
        (click)="consultarOperadoresConsulta()"
        style="margin-bottom: 10px !important"
      >
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
    </div>
    <app-spinner
      class="float-right col-6"
      *ngIf="showSpinnerConsulta"
    ></app-spinner>
    <div *ngIf="showGrillaConsulta" class="">
      <!-- <angular-slickgrid gridId="gridOperadoresConsulta" [columnDefinitions]="columnDefinitionsConsulta" [gridOptions]="gridOptionsConsulta"
        [dataset]="datasetConsulta" gridHeight="380" (onAngularGridCreated)="angularGridReadyConsulta($event)">
      </angular-slickgrid> -->
      <ag-grid-angular
        #grilla1
        class="ag-theme-alpine"
        style="width: 100%; height: 380px"
        [rowData]="datasetConsulta"
        [columnDefs]="columnDefinitionsConsulta"
        (gridReady)="onGridReady($event)"
        [enableCellTextSelection]="true"
      />
    </div>
  </nb-tab>
  <nb-tab
    *ngIf="usersRol.GESTIONAR_OPERADORES"
    tabTitle="Alta"
    tabIcon="upload-outline"
    responsive
    style="height: 80vh"
  >
    <div class="row">
      <div class="col-3 float-left">
        <p class="Titulo">Operadores</p>
        <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px">
          <mat-label>Nombre</mat-label>
          <input
            matInput
            #message2
            [type]=""
            name="nombre"
            [(ngModel)]="descripcionOperador"
          />
        </mat-form-field>
        <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px">
          <mat-label>Nombre Abreviado</mat-label>
          <input
            matInput
            #message2
            [type]=""
            name="nombreAbreviado"
            [(ngModel)]="descripcionAbreviadaOperador"
          />
        </mat-form-field>
        <p-dropdown
          required
          class="limited-selector"
          id="inputTipo"
          placeholder="Seleccionar Tipo Operador"
          [style]="{
            width: '100%',
            'margin-bottom': '10px',
            'margin-top': '10px'
          }"
          [options]="tipoOperador"
          [(ngModel)]="tipoOperadorSeleccionado"
          [virtualScroll]="true"
          [itemSize]="31"
          [filter]="true"
          [ngClass]="{
            'form-control-danger':
              firstForm.invalid && (firstForm.dirty || firstForm.touched)
          }"
          [panelStyle]="{ bottom: '100%', top: 'auto' }"
        >
        </p-dropdown>
        <p>
          <app-spinner *ngIf="showSpinnerAlta"></app-spinner>
          <button
            nbButton
            size="tiny"
            style="float: right"
            class="buttontz col-4"
            (click)="altaOperador()"
            *ngIf="!showSpinnerAlta"
          >
            Guardar
          </button>
        </p>
      </div>
      <div>
        <button
          nbButton
          shape="round"
          size="small"
          class="buttontz float-right"
          (click)="consultarOperadores()"
        >
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner class="float-right col-6" *ngIf="showSpinner"></app-spinner>
      <div *ngIf="showGrilla" class="float-right col-6">
        <!-- <angular-slickgrid gridId="gridOperadoresAlta" [columnDefinitions]="columnDefinitions" [gridOptions]="gridOptions"
          [dataset]="dataset" gridHeight="380" (onAngularGridCreated)="angularGridReady($event)">
        </angular-slickgrid> -->

        <ag-grid-angular
          #grilla2
          class="ag-theme-alpine"
          style="width: 100%; height: 380px"
          [rowData]="dataset"
          [columnDefs]="columnDefinitions"
          (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true"
        />
      </div>
    </div>
  </nb-tab>
  <nb-tab
    *ngIf="usersRol.GESTIONAR_OPERADORES"
    tabTitle="Modificación"
    tabIcon="edit-outline"
    responsive
    style="height: 80vh"
  >
    <div class="row">
      <div class="col-3 float-left">
        <p-dropdown
          required
          class="limited-selector"
          id="inputOperadores"
          placeholder="Seleccionar Operador"
          [style]="{
            width: '100%',
            'margin-bottom': '10px',
            'margin-top': '10px'
          }"
          [options]="OperadoresSelect"
          [(ngModel)]="operadorProcesado"
          (onChange)="obtenerDescripcionDropdown(operadorProcesado)"
          [virtualScroll]="true"
          [itemSize]="31"
          [filter]="true"
          [ngClass]="{
            'form-control-danger':
              firstForm.invalid && (firstForm.dirty || firstForm.touched)
          }"
        >
        </p-dropdown>
        <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px">
          <mat-label>Nombre</mat-label>
          <input
            matInput
            #message2
            [type]=""
            name="nombre"
            [(ngModel)]="descripcionOperadorModificar"
          />
        </mat-form-field>
        <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px">
          <mat-label>Nombre Abreviado</mat-label>
          <input
            matInput
            #message2
            [type]=""
            name="nombreAbreviado"
            [(ngModel)]="descripcionAbreviadaOperadorModificar"
          />
        </mat-form-field>
        <p-dropdown
          required
          class="limited-selector"
          id="inputTipo"
          placeholder="Seleccionar Tipo Operador"
          [style]="{
            width: '100%',
            'margin-bottom': '10px',
            'margin-top': '10px'
          }"
          [options]="tipoOperador"
          [(ngModel)]="tipoOperadorSeleccionadoModificar"
          [virtualScroll]="true"
          [itemSize]="31"
          [filter]="true"
          [ngClass]="{
            'form-control-danger':
              firstForm.invalid && (firstForm.dirty || firstForm.touched)
          }"
          [panelStyle]="{ bottom: '100%', top: 'auto' }"
        >
        </p-dropdown>
        <p>
          <nb-checkbox
            (checkedChange)="toggleEliminar($event)"
            [(ngModel)]="eliminarSeleccionado"
            >Eliminar</nb-checkbox
          >
        </p>
        <button
          nbButton
          size="tiny"
          style="float: right"
          class="buttontz col-4"
          (click)="modificarOperadores()"
        >
          Modificar
        </button>
      </div>
      <div>
        <button
          nbButton
          shape="round"
          size="small"
          class="buttontz float-right"
          (click)="consultarOperadoresModificar()"
        >
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner
        class="float-right col-6"
        *ngIf="showSpinnerGrillaModificar"
      ></app-spinner>
      <div *ngIf="showGrillaModificar" class="float-right col-6">
        <!-- <angular-slickgrid gridId="girdOperadoresModificar" [columnDefinitions]="columnDefinitionsModificar" [gridOptions]="gridOptions"
              [dataset]="datasetModificar" gridHeight="380" (onAngularGridCreated)="angularGridReadyModificar($event)">
            </angular-slickgrid> -->
        <ag-grid-angular
          #grilla3
          class="ag-theme-alpine"
          style="width: 100%; height: 380px"
          [rowData]="datasetModificar"
          [columnDefs]="columnDefinitionsModificar"
          (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true"
        />
      </div>
    </div>
  </nb-tab>
</nb-tabset>
